export default __webpack_public_path__ + "static/media/User.04cf8a7f.svg";